const state = {
    debugSettings: {
        statsEnabled: false,
        metricsEnabled: false
    }
};

const actions = {
    setDebugSettings({commit, dispatch}, newSettings) {
        commit('SET_DEBUG_SETTINGS', newSettings);
    },
    setDebugStats({commit, dispatch}, value) {
        commit('SET_DEBUG_STATS', value);
    },
    setDebugMetrics({commit, dispatch}, value) {
        commit('SET_DEBUG_METRICS', value);
    }
};

const mutations = {
    SET_DEBUG_SETTINGS(state, newSettings) {
        state.debugSettings = newSettings;
    },
    SET_DEBUG_STATS(state, value) {
        state.debugSettings.statsEnabled = value;
    },
    SET_DEBUG_METRICS(state, value) {
        state.debugSettings.metricsEnabled = value;
    }
};

export default {
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/debug.js